import api from './api';

const orderService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, val]) => {
      if (val !== undefined && val !== '' && val !== null) params.append(key, val);
    });
    const response = await api.get(`/orders?${params.toString()}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/orders/${id}`);
    return response.data;
  },

  create: async (orderData) => {
    const response = await api.post('/orders', orderData);
    return response.data;
  },

  updateItems: async (id, items) => {
    const response = await api.put(`/orders/${id}/items`, { items });
    return response.data;
  },

  // Flujo de estados
  accept: async (id) => {
    const response = await api.put(`/orders/${id}/accept`);
    return response.data;
  },

  startPreparing: async (id) => {
    const response = await api.put(`/orders/${id}/prepare`);
    return response.data;
  },

  markPrepared: async (id) => {
    const response = await api.put(`/orders/${id}/ready`);
    return response.data;
  },

  dispatch: async (id) => {
    const response = await api.put(`/orders/${id}/dispatch`);
    return response.data;
  },

  deliver: async (id) => {
    const response = await api.put(`/orders/${id}/deliver`);
    return response.data;
  },

  pay: async (id, paymentType) => {
    const response = await api.put(`/orders/${id}/pay`, { payment_type: paymentType });
    return response.data;
  },

  close: async (id) => {
    const response = await api.put(`/orders/${id}/close`);
    return response.data;
  },

  cancel: async (id) => {
    const response = await api.put(`/orders/${id}/cancel`);
    return response.data;
  },

  getHistory: async (id) => {
    const response = await api.get(`/orders/${id}/history`);
    return response.data;
  },

  print: async (id, format = 'html') => {
    const response = await api.get(`/orders/${id}/print?format=${format}`, { responseType: 'text' });
    return response.data;
  },

  getNcfStatus: async () => {
    const response = await api.get('/orders/ncf/status');
    return response.data;
  },
  // Eliminar orden cerrada (solo admin)
  deleteClosed(id, reason, comments) {
    return api.delete(`/sales/closed/${id}`, {
      data: { reason, comments }
    }).then(res => res.data);
  },
};

export default orderService;
